import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-4 text-charcoal-light font-light text-sm leading-relaxed" data-id="element-51">
    <h3 className="text-xl font-serif text-black mb-4" data-id="element-52">
      Política de Privacidad
    </h3>
    <p data-id="element-53">
      <strong className="font-bold text-charcoal" data-id="element-54">Última actualización:</strong>{' '}
      Abril 2026
    </p>
    <p data-id="element-55">
      Tu privacidad es importante para nosotros. Esta política describe cómo
      recopilamos, usamos y protegemos tu información personal cuando visitas
      nuestro sitio web o adquieres nuestros productos digitales.
    </p>
    <h4 className="font-bold text-charcoal mt-6" data-id="element-56">
      1. Información que recopilamos
    </h4>
    <p data-id="element-57">
      Recopilamos información que nos proporcionas directamente, como tu nombre
      y dirección de correo electrónico al realizar una compra o suscribirte a
      nuestra lista de correo.
    </p>
    <h4 className="font-bold text-charcoal mt-6" data-id="element-58">2. Uso de la información</h4>
    <p data-id="element-59">
      Utilizamos tu información para procesar tus compras, enviarte el producto
      digital adquirido, y comunicarnos contigo sobre actualizaciones relevantes
      relacionadas con tu compra.
    </p>
    <h4 className="font-bold text-charcoal mt-6" data-id="element-60">3. Protección de datos</h4>
    <p data-id="element-61">
      Implementamos medidas de seguridad técnicas y organizativas para proteger
      tu información personal contra acceso no autorizado, alteración o
      destrucción.
    </p>
    <h4 className="font-bold text-charcoal mt-6" data-id="element-62">4. Compartir información</h4>
    <p data-id="element-63">
      No vendemos, intercambiamos ni transferimos tu información personal a
      terceros. Esto no incluye terceros de confianza que nos asisten en la
      operación de nuestro sitio web o procesamiento de pagos, siempre que
      dichas partes acuerden mantener esta información confidencial.
    </p>
    <h4 className="font-bold text-charcoal mt-6" data-id="element-64">5. Cookies</h4>
    <p data-id="element-65">
      Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
      navegación. Puedes configurar tu navegador para rechazar cookies, aunque
      esto podría afectar algunas funcionalidades del sitio.
    </p>
    <h4 className="font-bold text-charcoal mt-6" data-id="element-66">6. Tus derechos</h4>
    <p data-id="element-67">
      Tienes derecho a acceder, rectificar o eliminar tu información personal en
      cualquier momento. Para ejercer estos derechos, puedes comunicarte con
      nosotros a través de los canales disponibles.
    </p>
  </div>;
const termsContent = <div className="space-y-4 text-charcoal-light font-light text-sm leading-relaxed" data-id="element-68">
    <h3 className="text-xl font-serif text-black mb-4" data-id="element-69">
      Términos y Condiciones
    </h3>
    <p data-id="element-70">
      <strong className="font-bold text-charcoal" data-id="element-71">Última actualización:</strong>{' '}
      Abril 2026
    </p>
    <p data-id="element-72">
      Al acceder y utilizar este sitio web y adquirir nuestros productos
      digitales, aceptas cumplir con los siguientes términos y condiciones.
    </p>
    <h4 className="font-bold text-charcoal mt-6" data-id="element-73">1. Productos digitales</h4>
    <p data-id="element-74">
      Los productos ofrecidos en este sitio son contenidos digitales
      descargables (eBooks). Una vez completada la compra, recibirás acceso
      inmediato al producto en formato PDF.
    </p>
    <h4 className="font-bold text-charcoal mt-6" data-id="element-75">2. Propiedad intelectual</h4>
    <p data-id="element-76">
      Todo el contenido de este sitio web y de los productos digitales,
      incluyendo textos, gráficos, logotipos e imágenes, está protegido por
      derechos de autor. Queda prohibida su reproducción, distribución o
      modificación sin autorización previa por escrito.
    </p>
    <h4 className="font-bold text-charcoal mt-6" data-id="element-77">3. Política de reembolso</h4>
    <p data-id="element-78">
      Ofrecemos una garantía de satisfacción de 30 días. Si no estás satisfecha
      con tu compra, puedes solicitar un reembolso completo dentro de los 30
      días posteriores a la fecha de compra.
    </p>
    <h4 className="font-bold text-charcoal mt-6" data-id="element-79">4. Uso permitido</h4>
    <p data-id="element-80">
      El producto adquirido es para uso personal únicamente. No está permitido
      compartir, revender o distribuir el contenido a terceros.
    </p>
    <h4 className="font-bold text-charcoal mt-6" data-id="element-81">
      5. Limitación de responsabilidad
    </h4>
    <p data-id="element-82">
      El contenido de nuestros productos es de carácter informativo y educativo.
      No nos hacemos responsables por decisiones tomadas basándose en el
      contenido de nuestros productos.
    </p>
    <h4 className="font-bold text-charcoal mt-6" data-id="element-83">6. Modificaciones</h4>
    <p data-id="element-84">
      Nos reservamos el derecho de modificar estos términos en cualquier
      momento. Las modificaciones entrarán en vigor inmediatamente después de su
      publicación en el sitio web.
    </p>
  </div>;
export const Footer: React.FC = () => {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 px-4 bg-charcoal text-center" data-id="element-85">
        <div className="flex items-center justify-center gap-2 mb-4" data-id="element-86">
          <div className="w-8 h-px bg-gold/40" data-id="element-87"></div>
          <span className="text-gold/60 text-xs" data-id="element-88">✦</span>
          <div className="w-8 h-px bg-gold/40" data-id="element-89"></div>
        </div>
        <div className="flex items-center justify-center gap-6 mb-4" data-id="element-90">
          <button onClick={() => setActiveModal('privacy')} className="text-cream/60 hover:text-gold text-xs md:text-sm font-light tracking-wide transition-colors duration-300" data-id="element-91">
            Política de Privacidad
          </button>
          <span className="text-cream/30" data-id="element-92">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-cream/60 hover:text-gold text-xs md:text-sm font-light tracking-wide transition-colors duration-300" data-id="element-93">
            Términos y Condiciones
          </button>
        </div>
        <p className="text-cream/30 text-xs font-light" data-id="element-94">
          © {new Date().getFullYear()} El Hombre Ideal para una Mujer
          Independiente. Todos los derechos reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-95">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-96">
            <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} transition={{
          duration: 0.3
        }} className="bg-cream w-full max-w-lg max-h-[80vh] overflow-y-auto p-6 md:p-10 relative shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-97">
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 text-charcoal-light hover:text-black transition-colors" aria-label="Cerrar" data-id="element-98">
                <XIcon className="w-5 h-5" data-id="element-99" />
              </button>
              {activeModal === 'privacy' ? privacyContent : termsContent}
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
};